import { CommonEnums } from '../../common.enums';
import { Input_Attr_Lnk } from './input_attr_lnk';
import { Attribute } from './attribute';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { Db_PropertyType } from '../datapoint/dbPropertyType';
import { Design } from './design';
import { RDesign_Inst } from './rdesign_inst';
import { Input_Attr_LnksUtil } from '../../utils/input_attr_lnks.util';
import { AttributesUtil } from '../../grids/attributes/attributes.util';

export class ReusableDesignInst {
    rDesign_Inst: RDesign_Inst;
    input_Attr_Lnks: Array<Input_Attr_Lnk>;
    attributes: Array<Attribute>;
    design: Design;
    change_Ind: string;
    error_Cd: string;
    error_Msg: string;
    ref_Id: number;
    ref_Cd: string;
    fldr_Id: number;
    fldrNm: string;
    expanded: boolean;
    gen_Tab_Change_Ind: string;
    outmapr_Tab_Change_Ind: string;
    inmapr_Tab_Change_Ind: string;
    rProp_Tab_Change_Ind: string;
    sel_Run_PropertyType_Cd: string;
    run_Properties: Array<Obj_Db_Property>;
    runPropertyTypes: Array<Db_PropertyType>;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.rDesign_Inst = new RDesign_Inst();
        this.input_Attr_Lnks = new Array<Input_Attr_Lnk>();
        this.attributes = new Array<Attribute>();
        this.design = new Design();
        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.error_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.fldrNm = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.expanded = false;
        this.gen_Tab_Change_Ind = CommonEnums.defaults.STRING_VAL_NO;
        this.outmapr_Tab_Change_Ind = CommonEnums.defaults.STRING_VAL_NO;
        this.inmapr_Tab_Change_Ind = CommonEnums.defaults.STRING_VAL_NO;
        this.rProp_Tab_Change_Ind = CommonEnums.defaults.STRING_VAL_NO;
        this.sel_Run_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.run_Properties = new Array<Obj_Db_Property>();
        this.runPropertyTypes = new Array<Db_PropertyType>();
    }

    static parse(reusableDesignInstTmp: ReusableDesignInst): ReusableDesignInst {
        let reusableDesignInst: ReusableDesignInst = new ReusableDesignInst();
        reusableDesignInst.copyFrom(reusableDesignInstTmp);
        return reusableDesignInst;
    }

    copy(): ReusableDesignInst {
        let reusableDesignInstTmp: ReusableDesignInst = new ReusableDesignInst();
        reusableDesignInstTmp.rDesign_Inst = this.rDesign_Inst.copy();
        reusableDesignInstTmp.design = this.design.copy();
        reusableDesignInstTmp.input_Attr_Lnks = Input_Attr_LnksUtil.getInstance().copy(this.input_Attr_Lnks);
        reusableDesignInstTmp.attributes = AttributesUtil.getInstance().copy(this.attributes);;
        reusableDesignInstTmp.design = this.design;
        reusableDesignInstTmp.change_Ind = this.change_Ind;
        reusableDesignInstTmp.error_Cd = this.error_Cd;
        reusableDesignInstTmp.error_Msg = this.error_Msg;
        reusableDesignInstTmp.ref_Id = this.ref_Id;
        reusableDesignInstTmp.ref_Cd = this.ref_Cd;
        reusableDesignInstTmp.fldr_Id = this.fldr_Id;
        reusableDesignInstTmp.fldrNm = this.fldrNm;
        reusableDesignInstTmp.expanded = this.expanded;
        reusableDesignInstTmp.gen_Tab_Change_Ind = this.gen_Tab_Change_Ind;
        reusableDesignInstTmp.outmapr_Tab_Change_Ind = this.outmapr_Tab_Change_Ind;
        reusableDesignInstTmp.inmapr_Tab_Change_Ind = this.inmapr_Tab_Change_Ind;
        reusableDesignInstTmp.rProp_Tab_Change_Ind = this.rProp_Tab_Change_Ind;
        reusableDesignInstTmp.sel_Run_PropertyType_Cd = this.sel_Run_PropertyType_Cd;
        reusableDesignInstTmp.run_Properties = this.run_Properties;
        reusableDesignInstTmp.runPropertyTypes = this.runPropertyTypes;

        return reusableDesignInstTmp;
    }

    copyFrom(reusableDesignInstTmp: ReusableDesignInst): void {
        this.rDesign_Inst = RDesign_Inst.parse(reusableDesignInstTmp.rDesign_Inst);
        this.design = Design.parse(reusableDesignInstTmp.design);
        Input_Attr_LnksUtil.getInstance().copyFrom(this.input_Attr_Lnks, reusableDesignInstTmp.input_Attr_Lnks);
        AttributesUtil.getInstance().copyFrom(this.attributes, reusableDesignInstTmp.attributes); this.change_Ind = reusableDesignInstTmp.change_Ind;
        this.error_Cd = reusableDesignInstTmp.error_Cd;
        this.error_Msg = reusableDesignInstTmp.error_Msg;
        this.ref_Id = reusableDesignInstTmp.ref_Id;
        this.ref_Cd = reusableDesignInstTmp.ref_Cd;
        this.fldr_Id = reusableDesignInstTmp.fldr_Id;
        this.fldrNm = reusableDesignInstTmp.fldrNm;
        this.expanded = reusableDesignInstTmp.expanded;
        this.gen_Tab_Change_Ind = reusableDesignInstTmp.gen_Tab_Change_Ind;
        this.outmapr_Tab_Change_Ind = reusableDesignInstTmp.outmapr_Tab_Change_Ind;
        this.inmapr_Tab_Change_Ind = reusableDesignInstTmp.inmapr_Tab_Change_Ind;
        this.rProp_Tab_Change_Ind = reusableDesignInstTmp.rProp_Tab_Change_Ind;
        this.sel_Run_PropertyType_Cd = reusableDesignInstTmp.sel_Run_PropertyType_Cd;
        this.run_Properties = reusableDesignInstTmp.run_Properties;
        this.runPropertyTypes = reusableDesignInstTmp.runPropertyTypes;
    }

    compare(reusableDesignInstTmp: ReusableDesignInst): string {
        let reusableDesignInstString: string = toString();
        let reusableDesignInstTmpString: string = reusableDesignInstTmp.toString();

        if (reusableDesignInstString != reusableDesignInstTmpString) {
            return reusableDesignInstString + ',' + reusableDesignInstTmpString
        }

        return '';
    }

    toString(): string {
        return "ReusableDesignInst [input_Attr_Lnks=" + this.input_Attr_Lnks +
            ", rDesign_Inst=" + this.rDesign_Inst + ", attributes=" + this.attributes + ", change_Ind=" + this.change_Ind +
            ", error_Cd=" + this.error_Cd + ", error_Msg=" + this.error_Msg + ", ref_Id=" + this.ref_Id +
            ", ref_Cd=" + this.ref_Cd + ", fldr_Id=" + this.fldr_Id + ", fldrNm=" + this.fldrNm +
            ", expanded=" + this.expanded + ", gen_Tab_Change_Ind=" + this.gen_Tab_Change_Ind +
            ", outmapr_Tab_Change_Ind=" + this.outmapr_Tab_Change_Ind + ", inmapr_Tab_Change_Ind=" + this.inmapr_Tab_Change_Ind +
            ", rProp_Tab_Change_Ind=" + this.rProp_Tab_Change_Ind + ", sel_Run_PropertyType_Cd=" + this.sel_Run_PropertyType_Cd +
            ", run_Properties=" + this.run_Properties + ", runPropertyTypes=" + this.runPropertyTypes + ",]";
    }
}